import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom'
import Header from './Nav/header'
import Footer from './Nav/footer'
import Sidebar from './Nav/sidebar';
import Login from './Pages/login'
import Dashboard from './Pages/dashboard';
import Airdrop from './Pages/airdrop';
import Member from './Pages/member';
import Advertisement from './Pages/advertisement';
import GameSetting from './Pages/gameSetting';
import Character from './Pages/character';
import UpgradeSetting from './Pages/upgradeSetting';
import JackpotSetting from './Pages/jactpotSetting';
import TouchImg from './Pages/touchImg';
import RandomBox from './Pages/randomBox';
import Notice from './Pages/notice';
import SoundManage from './Pages/soundManage';

import Example from './Pages/example';

// 지갑
import Common from './Pages/wallet/common';
import Network from './Pages/wallet/network';
import Token from './Pages/wallet/token';
import EventBanner from './Pages/wallet/eventBanner';

// 로그
import LogAccess from './Pages/log/logAccess';
import LogGold from './Pages/log/logGold';
import LogEnergy from './Pages/log/logEnergy';
import LogJackpot from './Pages/log/logJackpot';
import LogAirdrop from './Pages/log/logAirdrop';
import LogRandombox from './Pages/log/logRandombox';
import LogPoint from './Pages/log/logPoint';


function App() {
  return (
    <div className="App">
      <Header />
      <Sidebar />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/member" element={<Member />} />
        <Route path="/advertisement" element={<Advertisement />} />
        <Route path="/gameSetting" element={<GameSetting />} />
        <Route path="/character" element={<Character />} />
        <Route path="/upgradeSetting" element={<UpgradeSetting />} />
        <Route path="/jactpotSetting" element={<JackpotSetting />} />
        <Route path="/touchImg" element={<TouchImg />} />
        <Route path="/soundManage" element={<SoundManage />} />
        {/* <Route path="/notice" element={<Notice />} /> */}
        
        <Route path="/example" element={<Example />} />

        <Route path="/common" element={<Common />} />
        <Route path="/network" element={<Network />} />
        <Route path="/token" element={<Token />} />
        <Route path="/eventBanner" element={<EventBanner />} />

        <Route path="/logAccess" element={<LogAccess />} />
        <Route path="/logGold" element={<LogGold />} />
        <Route path="/logEnergy" element={<LogEnergy />} />
        <Route path="/logJackpot" element={<LogJackpot />} />
        <Route path="/logAirdrop" element={<LogAirdrop />} />

        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        {/* <Route path="/airdrop" element={<Airdrop />} /> */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
